module.exports = __webpack_public_path__ + "img/ak-sport.1f9aad72.png";